import { useEffect, useRef, useCallback } from "react";
import { authActions } from "../actions/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

export const useInactivityLogout = (logoutTime) => {
  const lastActivityTime = useRef(Date.now());
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const handleUserActivity = useCallback(() => {
    lastActivityTime.current = Date.now();
  }, []);

  useEffect(() => {
    const checkInactivity = () => {
      const inactiveDuration = Date.now() - lastActivityTime.current;

      if (
        inactiveDuration > logoutTime &&
        location.pathname !== "/" &&
        location.pathname !== "/lockscreen"
      ) {
        dispatch(authActions.setLock(true));
        dispatch(authActions.setAuth(null));
        navigate("/lockscreen", { replace: true });
      }
    };

    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("keydown", handleUserActivity);

    // Check every 30 seconds instead of every 1 second
    const checkInterval = setInterval(checkInactivity, 30000);

    return () => {
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("keydown", handleUserActivity);
      clearInterval(checkInterval);
    };
  }, [logoutTime, navigate, dispatch, location.pathname, handleUserActivity]);
};
